import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { ClientInformationData, Note, UpdateNoteSubject } from "../note-models";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { EditNoteCardModalComponent } from "../edit-note-card-modal/edit-note-card-modal.component";
import { NotesService } from "../notes.service";
import { EscapeHtmlPipe } from "../../../../conversations/sanitizer.pipe";
import { MomentModule } from "ngx-moment";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass, NgIf } from "@angular/common";
import { PinComponent, PINNED_STATUS_CHOICES } from "src/app/design-system/components/pin/pin.component";
import { PinnedModels } from "../../pinned-panel/pinned-models";

@Component({
    selector: "app-note-card",
    templateUrl: "./note-card.component.html",
    styleUrls: ["./note-card.component.scss"],
    imports: [NgClass, NgIf, TooltipModule, MomentModule, EscapeHtmlPipe, PinComponent]
})
export class NoteCardComponent implements OnInit {
  PINNED_STATUS_CHOICES = PINNED_STATUS_CHOICES;

  @Input() note: Note;
  @Input() clientInformation: ClientInformationData;
  @Input() isClientInformation: boolean = false;
  @Input() isPinned: boolean = false;
  @Input() disableClick: boolean = false;
  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private notesService: NotesService
  ) {}

  ngOnInit(): void {}
  pinTypeNote = PinnedModels.Note;

  openEditNoteModal(): void {
    if (this.disableClick) return;
    const initialState = {
      isClientInformation: this.isClientInformation,
      clientInformation: this.clientInformation,
      note: this.note,
      isPinned: this.isPinned,
    };
    this.bsModalRef = this.modalService.show(EditNoteCardModalComponent, {
      initialState,
      class: "modal-lg",
    });

    console.log("opened modal");
    this.bsModalRef.content.onClose.subscribe(
      (res: UpdateNoteSubject | boolean) => {
        console.log("closed modal");
        if (res && typeof res !== "boolean") {
          this.notesService.updateNoteSubject.next(res);
        }
      }
    );
  }

  checkAvatarForClientInformation(): boolean {
    if (this.clientInformation.last_edited_by) {
      return true;
    }
    return false;
  }
}
